'use client'

import { useAtomValue } from 'jotai'
import { ListRowImage } from '@/src/components/ui/list-row'
import { routeAtom } from '@/src/stores/route-machine/atoms'
import { ChainImg } from '../../ui/chain-img'
import { BasicStepRow } from './basic-step-row'

const ChainIcon = () => {
  const route = useAtomValue(routeAtom)

  if (!route?.sourceChain) {
    return null
  }

  return (
    <ChainImg
      chainId={route.sourceChain.chain_id}
      chainImg={route.sourceChain.chain_img}
      chainName={route.sourceChain.chain_name}
    />
  )
}

const Title = () => {
  const route = useAtomValue(routeAtom)

  if (!route) {
    return null
  }

  return (
    <div className='flex gap-3 items-center'>
      <ListRowImage
        src={route.InputAssetMetadata.logo_img_url}
        width={40}
        height={40}
        className='size-10 rounded-full'
        unoptimized
      />
      <div className='flex flex-col text-primary font-semibold items-baseline'>
        {route.InputAssetMetadata.ticker}{' '}
        <span
          data-testid='from-chain-name'
          className='font-normal text-sm leading-6 text-secondary'
        >
          on {route.sourceChain.chain_name}
        </span>
      </div>
    </div>
  )
}

export const RouteFromChain = () => {
  const route = useAtomValue(routeAtom)

  if (!route) {
    return null
  }

  return <BasicStepRow title={<Title />} icon={<ChainIcon />} hideBeforeLine />
}
